import { appid, TOKEN_ACCESS_FRONT } from './const';
import moment, {DurationInputArg2, Moment} from 'moment';
import immutable from 'immutable';
import {DEFAULT_AVATAR} from '@const';
import {SyntheticEvent} from 'react';
import {message} from 'antd';
import { cookie, environment } from '@gaodun.com/gtools';
import PhotoViewer from 'photoviewer';
import { PeriodListTypes, TeacherOrAssistantItem,EnumServiceTypes, EnumServiceRecordPhoneStatus, EnumServiceRecordLiveStatus, EnumFilterTaskStatus, EnumCommentsStatus } from '@types';
import qs from 'qs';
import { validateAuthority } from '../containers/authority-menu';
import { getUserBiToken } from '@api';
import jsonp from 'jsonp';


const W = window;

const _getActiveENV = () => {
    const hostname = window.location.hostname;
    if (hostname.indexOf('dev-') > -1 ) {
        return 't-';
    }
    if (hostname.indexOf('t-') > -1) {
        return 't-';
    }
    if (hostname.indexOf('pre-') > -1) {
        return 'pre-';
    }
    return '';
};

export const getActiveENV = () => _getActiveENV();

export const formatTime = (time: number, format: string, flag?: number) => {
    //此处flag参数用于在传入4000秒时返回01：06：40的正确格式，最终解释权归xiong
    if (!time) {
        return format.replace('Y', '0')
            .replace('M', '0')
            .replace('D', '0')
            .replace('h', '00')
            .replace('m', '00')
            .replace('s', '00');
    }
    const timeDate = new Date(time > 1000000000000 ? time : time * 1000);
    const repair = (v: number) => (v < 10 ? '0' : '') + v;
    const year = repair(timeDate.getFullYear());
    const month = repair(timeDate.getMonth() + 1);
    const day = repair(timeDate.getDate());
    let hour1 = +repair(timeDate.getHours()) - 8 < 10 ? '0' + (+repair(timeDate.getHours()) - 8) : +repair(timeDate.getHours()) - 8 + '';
    const hour = flag ? hour1 : repair(timeDate.getHours());
    const minutes = repair(timeDate.getMinutes());
    const seconds = repair(timeDate.getSeconds());
    return format.replace('Y', year)
        .replace('M', month)
        .replace('D', day)
        .replace('h', hour)
        .replace('m', minutes)
        .replace('s', seconds);
};

const dataURItoBlob = (dataURI: string) => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
    } else {
        byteString = unescape(dataURI.split(',')[1]);
    }

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type: mimeString});
};

const uuid = (len?: any, radix?: any, chars?: any) => {
    chars = (chars || '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz').split(
        '');
    const $uuid: any = [];
    let i;
    radix = radix || chars.length;

    if (len) {
        // Compact form
        for (i = 0; i < len; i++) $uuid[i] = chars[0 | Math.random() * radix];
    } else {
        // rfc4122, version 4 form
        let r;

        // rfc4122 requires these characters
        $uuid[8] = $uuid[13] = $uuid[18] = $uuid[23] = '-';
        $uuid[14] = '4';

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!$uuid[i]) {
                r = 0 | Math.random() * 16;
                $uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return $uuid.join('');
};


export const randomNumber = (upper: number, lower: number, frontier: boolean = false) => {
    return Math.floor(Math.random() * (upper - lower + Number(!frontier))) + lower;
};

export const getuuid = (len?: any, radix?: any, chars?: any) => uuid(len, radix, chars);

//判断是否为ie浏览器

/**
 * @return {number | string}
 */
export const judgeIEVersion = (): number | 'edge' => {
    const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; //判断是否IE<11浏览器
    const isEdge = userAgent.indexOf('Edge') > -1 && !isIE; //判断是否IE的Edge浏览器
    const isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
    if (isIE) {
        const reIE = new RegExp('MSIE (\\d+\\.\\d+);');
        reIE.test(userAgent);
        const fIEVersion = parseFloat(RegExp['$1']);
        if (fIEVersion == 7) {
            return 7;
        } else if (fIEVersion == 8) {
            return 8;
        } else if (fIEVersion == 9) {
            return 9;
        } else if (fIEVersion == 10) {
            return 10;
        } else {
            return 6;//IE版本<=7
        }
    } else if (isEdge) {
        return 'edge';//edge
    } else if (isIE11) {
        return 11; //IE11
    } else {
        return -1;//不是ie浏览器
    }
};

export const getBrowserType = () => {
    const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    const isOpera = userAgent.indexOf('Opera') > -1;
    if (isOpera) {
        return 'Opera';
    }
    //判断是否Opera浏览器
    if (userAgent.indexOf('Firefox') > -1) {
        return 'FF';
    } //判断是否Firefox浏览器
    if (userAgent.indexOf('Chrome') > -1) {
        return 'Chrome';
    }
    if (userAgent.indexOf('Safari') > -1) {
        return 'Safari';
    } //判断是否Safari浏览器
    if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) {
        return 'IE';
    }
    //判断是否IE浏览器
};

export const getOS = () => {
    const agent = navigator.userAgent.toLowerCase();
    const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
        return 'windows32';
    }
    if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
        return 'windows64';
    }
    if (isMac) {
        return 'mac';
    }
};

export const accDiv = (arg1: number, arg2: number) => {
    let t1 = 0, t2 = 0, r1, r2;
    try {
        t1 = arg1.toString().split('.')[1].length;
    } catch (e) {
        console.log();
    }
    try {
        t2 = arg2.toString().split('.')[1].length;
    } catch (e) {
        console.log();
    }
    r1 = Number(arg1.toString().replace('.', ''));
    r2 = Number(arg2.toString().replace('.', ''));
    return (r1 / r2) * Math.pow(10, t2 - t1);
};

export const accMul = (arg1: number, arg2: number) => {
    arg1 = arg1 || 0;
    arg2 = arg2 || 0;
    let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
    try {
        m += s1.split('.')[1].length;
    } catch (e) {
        console.log();
    }
    try {
        m += s2.split('.')[1].length;
    } catch (e) {
        console.log();
    }
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
};

export const diffWeeks = (start: string | number, end: string | number): { sw: number, ew: number, diffWeek: number, sd: number, ed: number, diffDay: number } => {
    const s = moment(start);
    const e = moment(end);
    const sd = 8 - s.weekday();
    const ed = e.weekday();
    const diff = e.diff(s, 'days') + 1 - sd - ed;
    return {
        sw: s.weekday(),
        ew: e.weekday(),
        sd,
        ed,
        diffWeek: diff < 0 ? 0 : Math.floor(diff / 7) + 2,
        diffDay: diff
    };
};

export const transformDurationTime = (time: any, type?: DurationInputArg2,isSecond?:boolean) => {
    if (!time) {
        return {
            h: 0,
            m: 0,
            date: 0,
            time: '0分钟'
        };
    }
    const repair = (v: number) => (v < 10 ? '0' : '') + v;
    const date = moment.duration(time, type || 'minutes');
    const h = date.get('days') * 24 + date.get('hours');
    const m = date.get('minutes');
    const s = date.get('seconds');
    return {
        s,
        h,
        m,
        date,
        time:isSecond ? `${h && h !=0 ? repair(h) + ':' : ''}${m && m !=0 ? repair(m) + ':' : '00 : '}${s && s !=0 ? repair(s) : '00'}` :`${h ? h + '小时' : ''}${m ? m + '分钟' : ''}`
    };
};

export function getLinkSearch(key: string) {
    let pairs = window.location.search.slice(1).split('&') || [];
    let result: any = {};
    pairs.forEach(function (pair: any) {
        if (pair && pair.indexOf('=') !== -1) {
            pair = pair.split('=');
            //兼容写法
            let keyData: string = pair[0].toLocaleLowerCase();
            result[keyData] = decodeURIComponent(pair[1] || '');
        }
    });
    return result[key];
}

export const loginTimeout = (msg = '登录过期', msgInstance: 'warning' | 'success' | 'error' | 'info' = 'warning') => {
    setTimeout(() => {
        message[msgInstance](msg, 1, () => {
            W.location.replace(window.__POWERED_BY_QIANKUN__ ? '/login' : `https://${getActiveENV()}cloud.gaodun.com/login`);
        });
    }, 0);
};

export const percentJudge = (prePercent: any) => {
    let pre = accMul(prePercent, 100);
    if ([0, 100].includes(pre)) {
        return pre;
    }
    if (pre > 99) {
        return 99;
    }
    if (pre > 1) {
        pre = Math.round(pre);
    } else if (pre > 0) {
        pre = 1;
    }
    return pre;
};

export const changeLectureNoteUrl = (link: any, title: any) => {
    const token = cookie.getCookie(TOKEN_ACCESS_FRONT);
    if (link === undefined) {
        return null;
    }
    if (link.toLowerCase().indexOf('.pdf') > 0) {
        const {protocol} = window.location;
        if (link.indexOf('//') === 0 || link.indexOf('https://') === 0 || link.indexOf('http://') === 0) {
            link = link.replace(/(\/\/)|(https:\/\/)|(http:\/\/)/, '');
        }
        const regEn = /[`~!@#$%^&*()_+<>?:"{},.\\/;'[\]]/g;
        const regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/g;
        title = title.replace(regCn, '').replace(regEn, '');
        title = !title ? +new Date() : title;
        return `${protocol}//${getActiveENV()}apigateway.gaodun.com/calais/front/v1/file-open-repeater/${title}.pdf?path=${link}&token=${token}`;
    } else {
        return link;
    }
};
/*
* data:需要toJS的数据
* valueInFalse:无法toJS时返回的值，默认返回data本身
* */
export const iToJS = (data: any, valueInFalse: any = data): any => {
    if (data &&
		!(immutable.Map.isMap(data) ||
			immutable.List.isList(data) ||
			immutable.Set.isSet(data) ||
			immutable.Seq.isSeq(data)
		)
    ) {
        return data;
    }
    if (data) {
        return data.toJS();
    }
    return valueInFalse;
};

export const isElementInViewport = (el: HTMLElement, offset: number = 0) => {
    const box = el.getBoundingClientRect(),
        top = (box.top >= 0),
        left = (box.left >= 0),
        bottom = (box.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset),
        right = (box.right <= (window.innerWidth || document.documentElement.clientWidth) + offset);
    return (top && left && bottom && right);
};

export const scrollToView = (el: HTMLElement | null, offset: number = 0, options: any = true) => {
    if (!el) {
        return false;
    }
    if (!isElementInViewport(el, offset)) {
        el.scrollIntoView && el.scrollIntoView(options);
    }
};

export const avatarError = (e: SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = DEFAULT_AVATAR;
};

export const getQueryString = (name: string) => {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
};

export const getDateDiff = (startTime: string | number | Moment, endTime: string | number | Moment) => {
    const start = moment(startTime);
    const end = moment(endTime);
    const years = moment(end).diff(moment(start), 'years');
    const months = moment(end).diff(moment(start), 'months');
    const days = moment(end).diff(moment(start), 'days');
    const hours = moment(end).diff(moment(start), 'hours');
    const minutes = moment(end).diff(moment(start), 'minutes');
    const seconds = moment(end).diff(moment(start), 'seconds');

    let diffTime: string = '';
    if (years) {
        diffTime = `${years}年前`;
    } else if (months) {
        diffTime = `${months}月前`;
    } else if (days) {
        diffTime = `${days}天前`;
    } else if (hours) {
        diffTime = `${hours}小时前`;
    } else if (minutes) {
        diffTime = `${minutes}分钟前`;
    } else if (seconds) {
        diffTime = `${seconds}秒前`;
    }

    return {
        years,
        months,
        days,
        hours,
        minutes,
        seconds,
        diffTime
    };
};

export const timeToMoment = (value: any): Moment => {
    if (typeof value === 'number') {
        return value.toString().length === 10 ? moment.unix(value) : moment(value);
    }
    return moment(value);
};

/**
 * 获取问题响应时长
 * @param warnPoint 预警时间
 * @param timeoutPoint 超时时间
 * @param currentStatus 状态：0.未分配；2.未回答；4.对追问未分配的；3.追问未回答的  1.已回答；6.已关闭
 * @param answerStartTimePoint 提问时间
 * @param lastAnswerTime 最后回答时间
 * @param answerDuration 响应时长 h
 * @return {Object} 描述内容 文本程度
 */
export const getQuestionAnswerTime = (warnPoint: any, timeoutPoint: any, currentStatus: number, answerStartTimePoint: any, lastAnswerTime: any, answerDuration: number,) => {
    if (!answerDuration) {
        return {
            content: '',
            type: undefined
        };
    }
    const warnTimeMoment = timeToMoment(warnPoint);
    const timeoutMoment = timeToMoment(timeoutPoint);
    const startTimeMoment = timeToMoment(answerStartTimePoint);
    const answerTimeMoment = timeToMoment(lastAnswerTime);
    let content: string = '';
    let type: 'danger' | 'success' | 'warning' | 'secondary' | undefined = 'danger';
    if ([0, 2, 3, 4].includes(currentStatus)) {
        if (moment().isSameOrBefore(timeoutMoment)) {
            const diffHours = timeoutMoment.diff(moment(), 'hours'); //截断为零个小数位，并返回一个整数
            const diffMinutes = moment.duration(timeoutMoment.diff(moment())).minutes();
            content = diffHours === 0 ? `${diffMinutes || 1}分钟后超时` : `${diffHours}小时${diffMinutes || 1}分钟后超时`;
            type = moment().isAfter(warnTimeMoment) ? 'warning' : undefined;
        } else if (moment().isAfter(timeoutMoment)) {
            const diffHours = moment().diff(timeoutMoment, 'hours');
            const diffMinutes = moment().diff(timeoutMoment, 'minutes');
            content = diffHours === 0 ? `已超时${diffMinutes || 1}分钟` : `已超时${diffHours}小时`;
        }
    } else if (answerTimeMoment.valueOf()) {//已回答  已关闭
        const responseHoursTime = answerTimeMoment.diff(startTimeMoment, 'hours', true);
        const diffMinutes = moment.duration(answerTimeMoment.diff(startTimeMoment)).minutes() ;
        const outPointHours = answerTimeMoment.diff(timeoutMoment, 'hours', true); // 超时小时
        const outPointMinutes = moment.duration(answerTimeMoment.diff(timeoutMoment)).minutes() ; // 超时分钟
        if (isNaN(responseHoursTime)){
            content = '';
        } else {
            if (responseHoursTime > answerDuration) {//超时
                content = Math.floor(outPointHours) === 0 ? `超时，${outPointMinutes || 1}分钟响应` : `超时，${Math.floor(outPointHours)}小时${outPointMinutes || 1}分钟响应`;
            } else { //正常
                type = undefined;
                content = Math.floor(responseHoursTime) <= 0 ? diffMinutes <= 0 ? '正常，秒回' : `正常，${diffMinutes}分钟响应` : `正常，${Math.floor(responseHoursTime)}小时${diffMinutes || 1}分钟响应`;
            }
        }
    }
    return {
        content,
        type
    };
};

/**
 * 获取答疑详情页的问题实际响应时长
 */
export const getDetailAnswerTime = (answered:number, answerTime:number | null, answerStartTimePoint:string | null, answerDuration: number | null) => {
    const startTimeMoment = timeToMoment(answerStartTimePoint);
    const answerTimeMoment = timeToMoment(answerTime);
    const timeoutMoment = moment(startTimeMoment).add(answerDuration,'hours');
    let content:string = '';
    if (answered === 1) {
        const responseHoursTime = answerTimeMoment.diff(startTimeMoment, 'hours', true);
        const diffMinutes = moment.duration(answerTimeMoment.diff(startTimeMoment)).minutes();
        if (isNaN(responseHoursTime) || !answerDuration){
            content = '';
        } else {
            //由于answerDuration单位是h,所以answerDuration如果存在最小值是0,responseHoursTime最小值也可能为零，即响应时间在一小时之内
            if (responseHoursTime > answerDuration) {//超时，这种情况responseHoursTime肯定>=1
                content = `实际响应时长：${Math.floor(responseHoursTime)}小时${diffMinutes || 1}分钟响应，超时${Math.floor(responseHoursTime)-answerDuration ? `${Math.floor(responseHoursTime)-answerDuration}小时` : ''}${diffMinutes || 1}分钟`;
            } else { //正常
                content = Math.floor(responseHoursTime) <= 0 ? diffMinutes <= 0 ? '实际响应时长：正常，秒回' : `实际响应时长：${diffMinutes}分钟，未超时` : `实际响应时长：${Math.floor(responseHoursTime)}小时${diffMinutes || 1}分钟，未超时`;
            }
        }
    } else {
        if (moment().isSameOrBefore(timeoutMoment)) {
            const diffHours = timeoutMoment.diff(moment(), 'hours'); //截断为零个小数位，并返回一个整数
            const diffMinutes = moment.duration(timeoutMoment.diff(moment())).minutes();
            content = diffHours === 0 ? `${diffMinutes || 1}分钟后超时` : `${diffHours}小时${diffMinutes || 1}分钟后超时`;
        } else if (moment().isAfter(timeoutMoment)) {
            const diffHours = moment().diff(timeoutMoment, 'hours');
            const diffMinutes = moment.duration(moment().diff(timeoutMoment)).minutes();
            content = diffHours === 0 ? `已超时${diffMinutes || 1}分钟` : `已超时${diffHours}小时${diffMinutes || 1}分钟`;
        }
    }
    return {
        content,
    };
};

// 下划线转换驼峰
export const toHump = (name: string) => {
    return name.replace(/_(\w)/g, function(all, letter){
        return letter.toUpperCase();
    });
};

// 驼峰转换下划线
export const toLine = (name: string) => {
    return name.replace(/([A-Z])/g,'_$1').toLowerCase();
};

export const toTriggerLineOrHump = (obj: any, isLine: boolean = true) => {
    let newObj: any = {};
    switch (obj && obj.constructor) {
    case Object:
        for (let key in obj) {
            newObj[isLine ? toLine(key) : toHump(key)] = toTriggerLineOrHump(obj[key], isLine);
        }
        return newObj;
    case Array:
        return obj.map((item: any) => {
            return toTriggerLineOrHump(item, isLine);
        });
    default:
        return obj;
    }
};

export const showImages = (images: PhotoViewer.Img[]) => {
    const options = {
        index: 0,
        i18n: {
            minimize: '最小化',
            maximize: '最大化',
            close: '关闭',
            zoomIn: '放大(+)',
            zoomOut: '缩小(-)',
            prev: '上一张(←)',
            next: '下一张(→)',
            fullscreen: '全屏',
            actualSize: '真实大小(Ctrl+Alt+0)',
            rotateLeft: '向左旋转(Ctrl+,)'
            ,rotateRight: '向右旋转(Ctrl+.)'
        }
    };
    new PhotoViewer(images, options);
};

export const arrayToHeavy = (arr:number[]) => {
    //过滤掉原数组中重复的数字，返回新的数组
    return arr.filter((item:number,index:number) => {
        return arr.indexOf(item) === index;
    });
};

export const numToArray = (val:number) => {
    let arr: any = [];
    arr.push(val);
    return arr;
};

// 校验时间段是否有重叠
export const validDateOverlap = (arrList: PeriodListTypes[]) => {
    const sArr: string [] = [];
    const eArr: string [] = [];
    arrList.map(function(item) {
        sArr.push(item.startTime);
        eArr.push(item.endTime);
    });
    const _sArr = sArr.sort();
    const _eArr = eArr.sort();
    let flag = 0;
    for ( let k = 1; k < _sArr.length; k++ ){
        if ( _sArr[k] <= _eArr[k-1] ) {
            flag += 1;
        }
    }
    return flag > 0;
};

export const filterFulltime = (v: number | null) => {
    switch (v) {
    case 0:
        return '全职';
    case 1:
        return '兼职';
    default: 
        return '--';
    }
};
export const translateStringBylist = (list: TeacherOrAssistantItem[]) => {
    if (!list || list.length === 0) return '--';
    let arr: any = [];
    arr = list.map(v => v.teacherName);
    return arr.join(',');
};
export const filterClassStatus = (v: number | null) => {
    switch (v) {
    case 0:
        return '未开始';
    case 1:
        return '进行中';
    case 2:
        return '已结束';
    default: 
        return '--';
    }
};
export const parseUrlParams = () : any => {
    let url = window.location.href;
    let result = url.indexOf('?') > -1 ? qs.parse(url.substring(url.indexOf('?') + 1)) : {};
    return result;
};

export const isToday = (createdAt:string) => {
    // 将 createdAt 转换为 Date 对象
    const createdDate = new Date(createdAt);
    
    // 获取当前的日期
    const today = new Date();
  
    // 比较年份、月份和日期
    return createdDate.getFullYear() === today.getFullYear() &&
           createdDate.getMonth() === today.getMonth() &&
           createdDate.getDate() === today.getDate();
}

/**
 * 判断用户是否今天第一次进来
 */
export const echartsTimeRefresh = () => {
    const time = localStorage.getItem('echartsTimeRefresh');
    const isToday = time !== moment().format('YYYY-MM-DD');
    // 不是同一天 更新本地缓存
    if (isToday) {
        localStorage.setItem('echartsTimeRefresh',moment().format('YYYY-MM-DD'));
    }
    return isToday;
};

export const serviceTypeFormat = (key:number) => {
    let result = '';
    switch (key) {
    case EnumServiceTypes.face :
        result = '面授';
        break;
    case EnumServiceTypes.phone :
        result = '电话';
        break;
    case EnumServiceTypes.live :
        result = '直播';
        break;
    }
    return result;
};

//获取图片域名
export const getSimg01Domain = () => {
    return `//${getActiveENV()}simg01.gaodunwangxiao.com/`;
};
//格式化服务记录打电话状态值 直播：1-正常 2-学生未到 4-其他 电话： 1-正常 2-无人接听 3-空号 4-其他 5-已接通 6-未接通
export const serviceRecordPhoneStatusFormat = (type:number) => {
    const resString = ['其他', '正常', '学生未到', '空号', '其他', '已接通', '未接通', '其他2', '其他3'];
    return resString[type];
    // let res = '';
    // if (type === EnumServiceRecordPhoneStatus.emptyPhone){
    // 	res = '空号';
    // } else if (type === EnumServiceRecordPhoneStatus.normal){
    // 	res = '正常';
    // } else if (type === EnumServiceRecordPhoneStatus.noAnswer){
    // 	res = '无人接听';
    // } else if (type === EnumServiceRecordPhoneStatus.other){
    // 	res = '其他';
    // } else if (type === EnumServiceRecordPhoneStatus.other){
    // 	res = '已接通';
    // } else if (type === EnumServiceRecordPhoneStatus.other){
    // 	res = '其他';
    // }
    // return res;

};
//格式化服务记录直播状态值 直播：1-正常 2-学生未到 4-其他 电话： 1-正常 2-无人接听 3-空号 4-其他
export const serviceRecordLiveStatusFormat = (type:number) => {
    let res = '';
    if (type === EnumServiceRecordLiveStatus.studentUnIn){
        res = '学生未到';
    } else if (type === EnumServiceRecordLiveStatus.normal){
        res = '正常';
    } else if (type === EnumServiceRecordPhoneStatus.other){
        res = '其他';
    }
    return res;
};
//服务列表 任务状态格式化  0 未开始 1上课中 2已完成 3已取消 4待反馈 5已反馈
export const processStatusFormat = (key:number) => {
    let result = '';
    switch (key) {
    case EnumFilterTaskStatus.unStart :
        result = '未开始';
        break;
    case EnumFilterTaskStatus.inClass :
        result = '上课中';
        break;
    case EnumFilterTaskStatus.completed :
        result = '已完成';
        break;
    case EnumFilterTaskStatus.canceled :
        result = '已取消';
        break;
    case EnumFilterTaskStatus.waitingFeedback :
        result = '已完成';
        break;
    case EnumFilterTaskStatus.hasFeedback :
        result = '已反馈';
        break;
    }
    return result;
};

//格式化学员评价状态 是否评价 0 未评价 1 已评价
export const commentsStatusFormat = (status:number) => {
    let res = '未评价';
    if (status === EnumCommentsStatus.done){
        res = '已评价';
    }
    return res;

};

//获取eds域名
export const getEdsDomain = () => {
    return `//${getActiveENV()}eds2.gaodun.com/`;
};

// 微前端中 新打开页面basename
export const blankBaseName = window.__POWERED_BY_QIANKUN__ ? '/system/gtrs' : '';

export const validateAuthorityBtn = (key:string, locationUrl?:string) => {
    const url = (locationUrl || location.pathname).replace(blankBaseName, '');//处理微前端里面的路由
    return validateAuthority(key, url);
};
export const gotoBIData = async (vigoUserId:number|undefined ) => {
    const GDSID = cookie.getCookie(`${getActiveENV()}GDSID`);
    const res = await getUserBiToken({
        GDSID,
        appId: appid, // appid
    });
    if (res.data && res.data.status === 0) {
        jsonp(`https://fanruan.gaodun.com/WebReport/decision/login/cross/domain?fine_username=${vigoUserId}&fine_password=${res.data.result.UserBiToken}&validity=-1`, (ret: any) => {
            window.open('http://fanruan.gaodun.com/WebReport/decision/v5/design/report/9be4441a19e649a2beb2e6d0811802c7/view');
        });
    } else {
        message.info('获取UserBiToken失败！');
    }
};
export const initG2player = (videoId: any, videoTime?: number) => {
    const token = cookie.getCookie('accessAdmintoken');
	  console.log('🚀 ~ file: index.ts:752 ~ initG2player ~ token:', token);
	  // 播放器初始化
	  const option = {
        className: 'commonVideo',
        accessToken: token,
        env: environment.getEnv(),
        initialTime: videoTime ? videoTime : 0
    };
    //@ts-ignore 播放器初始化
    window.initG2player(videoId, option);
};


export const loadJS = (url, success?: any) => {
    const domScript = document.createElement('script');
    domScript.src = url;
    success = success || function () {};
    domScript.onload = domScript['onreadystatechange'] = function () {
        //@ts-ignore
        if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
            success();
            //@ts-ignore
            this.onload = this.onreadystatechange = null;
            this.parentNode?.removeChild(this);
        }
    };
    document.getElementsByTagName('head')[0].appendChild(domScript);
};

export const loadCss = url => {
    const myCSS = document.createElement('link');
    myCSS.rel = 'stylesheet';
    myCSS.href = url;
    document.head.insertBefore(myCSS, document.head.childNodes[document.head.childNodes.length - 1].nextSibling);
};